import React from 'react'

const ResumeBuild = () => {
  return (
    <div>
      <h1>Welcome to ResumeBuilder page </h1>
    </div>
  )
}

export default ResumeBuild